"use client";
import AppLayout from "@/components/app/applayout";
import Header from "@/components/dashboard/blogs/header";
import TagSearch from "@/components/dashboard/blogs/tagSearch";
import PublishedBlog from "@/components/dashboard/blogs/publishedBlog";
import { AppSize, pxToRem } from "@/util";
import {
  Box,
  Typography,
} from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import FootPagination from "@/components/listings/footPagination";


export default function BlogPage() {
  const { classes } = styles();
  return (
    <AppLayout>
      <Box className={`${classes.container}`}>
        <Header />
        <Box className={classes.display}>
          <Box className={classes.searchCont}>
             <Typography className={classes.blogHeading}>
              Our Latest Blog
            </Typography>

            <TagSearch />
            
          </Box>
          {/* search on mobile */}
          {/**<Box className={`${classes.mobileNav}`}>
            <Paper className={`${classes.mobile}`} elevation={2}>
              <TextField
                // className={classes.input}
                fullWidth
                variant="outlined"
                placeholder="Search for Blog"
                // value={propertyName}
                // onChange={(e) => dispatch(setPropertyName(e.target.value))}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        aria-label="search"
                        // onClick={() => dispatch(setSearch(true))}
                      >
                        <SearchIcon fontSize="large" />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        aria-label="search"
                        // onClick={() => setOpenFilt(true)}
                      >
                        <TuneIcon fontSize="large" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Paper>
          </Box> */}
          <Box>
           
            <Box sx={{ marginTop: pxToRem(24) }}>
              <PublishedBlog />
            </Box>
          </Box>
          <Box>
            <FootPagination />
          </Box>
        </Box>
      </Box>
    </AppLayout>
  );
}
const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    minHeight: pxToRem(500),
  },
  display: {
    padding: `${pxToRem(40)} ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(20)}`,
    },
  },
  searchCont:{
   display:'flex',
   justifyContent:'space-between',
   alignItems:'center',
   flexWrap:'wrap'
  },
  blogHeading: {
    fontSize: pxToRem(38),
    fontWeight: 700,
    lineHeight: "120%",
    fontFamily: "Playfair Display",
    margin: `${pxToRem(10)} ${pxToRem(0)} `,
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(34),
      width: "100%",
    },
  },
  debug: {
    border: "1px solid green",
  },
  mobileNav: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: `0px ${pxToRem(AppSize.padding)}`,
    },
    [theme.breakpoints.down(600)]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: `0px ${pxToRem(20)}`,
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: `0px`,
      marginBottom: pxToRem(20),
    },
  },
  mobile: {
    width: "100%",
    zIndex: 10,
  },
}));
